/**
 * Auth context fields for volunteer opportunity APIs (account_id, user_id, role).
 * Volunteer Impact Dashboard uses user_id to scope hours to the user's signups.
 * @param {{ account_id?: string, user_id?: string, role?: string }} session
 * @param {Record<string, unknown>} [extra]
 */
export function volunteerOpportunityRequestBody(session, extra = {}) {
  return {
    account_id: session?.account_id,
    user_id: session?.user_id,
    role: session?.role,
    ...extra,
  };
}
